import { cn } from './utils';

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

const usdCompactFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

function formatUsd(n: number | null | undefined, opts?: { compact?: boolean }): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return (opts?.compact ? usdCompactFormatter : usdFormatter).format(n);
}

/**
 * Right-aligned monospace USD figure. Use for any column where money is
 * the primary signal — keeps decimal points aligned.
 */
export function UsdCell({
  value,
  compact,
  className,
}: {
  value: number | null | undefined;
  compact?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'font-num text-right tabular-nums',
        value === null || value === undefined ? 'text-muted-foreground' : 'text-foreground',
        className,
      )}
    >
      {formatUsd(value, { compact })}
    </span>
  );
}
